import "./About.css";
import AboutSecondSection from "./AboutSecondSection";
import BgAnim from "../../../components/BgAnimShape";
import OurSmpl from "./OurSmpl";
import PluginScale from "./PluginScale";
import OurTeam from "./OurTeam";
import WhySmpl from "./WhySmpl";
import ContactUs from "./ContactUs";

import AboutHero from "./AboutHero";
import Footer from "../../../global/footer/Footer";
import ScrollTop from "../../../components/ScrollTop";

export default function About() {
  return (
    <>
      <AboutHero />
      <div className="about-page-wrapper">
        <div className="about-bg-anim">
          <BgAnim />
        </div>
        <AboutSecondSection />
        <OurSmpl />
        <PluginScale />
        <OurTeam />
        <WhySmpl />
        <ContactUs />
        <ScrollTop />
        <Footer />
      </div>
    </>
  );
}
